(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        document.addEventListener("DOMContentLoaded", (() => {
            const swiperContainer = document.querySelector(".c-bas-swiper");
            if (swiperContainer) {
                const swiper = new Swiper(".c-bas-swiper", {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,
                    autoHeight: true,
                    navigation: {
                        nextEl: ".c-bas-next",
                        prevEl: ".c-bas-prev"
                    },
                    pagination: {
                        el: ".c-bas-pagination",
                        clickable: true
                    }
                });
                const section = document.querySelector(".c-bas-section");
                if (section) {
                    section.addEventListener("click", (e => {
                        const btn = e.target.closest("button");
                        if (!btn || !btn.closest(".c-bas-toggle-controls")) return;
                        const imageArea = btn.closest(".c-bas-slide");
                        if (!imageArea) return;
                        const type = btn.dataset.type;
                        const buttons = imageArea.querySelectorAll(".c-bas-toggle-controls button");
                        buttons.forEach((b => b.classList.remove("active")));
                        btn.classList.add("active");
                        const imgBefore = imageArea.querySelector(".c-bas-img-before");
                        const imgAfter = imageArea.querySelector(".c-bas-img-after");
                        if (imgBefore && imgAfter) {
                            if (type === "before") {
                                imgBefore.classList.add("c-bas-img-visible");
                                imgBefore.classList.remove("c-bas-img-hidden");
                                imgAfter.classList.remove("c-bas-img-visible");
                                imgAfter.classList.add("c-bas-img-hidden");
                            } else {
                                imgAfter.classList.add("c-bas-img-visible");
                                imgAfter.classList.remove("c-bas-img-hidden");
                                imgBefore.classList.remove("c-bas-img-visible");
                                imgBefore.classList.add("c-bas-img-hidden");
                            }
                        }
                    }));
                }
            }
        }));
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();